var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5999 19.8C9.5999 20.7942 8.79401 21.6 7.7999 21.6C6.80579 21.6 5.9999 20.7942 5.9999 19.8C5.9999 18.8059 6.80579 18 7.7999 18C8.79401 18 9.5999 18.8059 9.5999 19.8Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 19.8C17.9999 20.7942 17.194 21.6 16.1999 21.6C15.2058 21.6 14.3999 20.7942 14.3999 19.8C14.3999 18.8059 15.2058 18 16.1999 18C17.194 18 17.9999 18.8059 17.9999 19.8Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5999 4.80005C2.93716 4.80005 2.3999 5.33731 2.3999 6.00005V18C2.3999 18.6628 2.93716 19.2 3.5999 19.2H4.85991C5.13788 17.8307 6.34853 16.8 7.7999 16.8C9.25128 16.8 10.4619 17.8307 10.7399 19.2H11.9999C12.6626 19.2 13.1999 18.6628 13.1999 18V6.00005C13.1999 5.33731 12.6626 4.80005 11.9999 4.80005H3.5999Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 8.40005C16.1372 8.40005 15.5999 8.93731 15.5999 9.60005V16.8601C15.7938 16.8207 15.9944 16.8 16.1999 16.8C17.6513 16.8 18.8619 17.8307 19.1399 19.2H20.3999C21.0626 19.2 21.5999 18.6628 21.5999 18V12C21.5999 11.6818 21.4735 11.3766 21.2484 11.1515L18.8484 8.75152C18.6234 8.52648 18.3182 8.40005 17.9999 8.40005H16.7999Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.85fd0fbdd500173edf752f3cf5e37cca.svg";
export { ForwardRef as ReactComponent };